import request from '@/util/request';

export const getList = (params, options) =>
request.get('/api/deviceinspectstandard/standardPage', Object.assign({}, options, { params }));

export const getBisDictData = (params, options) =>
    request.get('/api/v4ward/projectDict/dictionary', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/deviceinspectstandard/standardDetail', Object.assign({}, options, { params }))

// export const remove = (params, options) =>
// request.post('/api/deviceinspectstandard/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/deviceinspectstandard/standardSave', params,options)

export const update = (params, options) =>
request.post('/api/deviceinspectstandard/standardSubmit', params,options)



export const standardRemove = (id) =>
request.post('/api/deviceinspectstandard/standardRemove?ids='+id)

export const forbidStandard = (params, options) =>
request.post('/api/deviceinspectstandard/startToStop',params,options)

//巡检标准（填写）
export const  taskStandardReadingByDevice = (params, options) =>
request.get('/api/deviceinspecttasklist/taskStandardReadingByDevice', Object.assign({}, options, { params }));

//巡检记录
export const  getInspectionList = (params, options) =>
request.get('/api/deviceinspecttasklist/taskPage', Object.assign({}, options, { params }));

//新增巡检记录--根据设备id获取标准

export const  getStandardByDeviceId = (params, options) =>
request.get('/api/deviceinspecttasklist/taskStandardByDevice', Object.assign({}, options, { params }));

//保存巡检记录
export const saveInspectRecord = (params, options) =>
request.post('/api/deviceinspecttasklist/taskSave',params,options)

//巡检记录查看

export const  watchInspectRecordRecord  = (params, options) =>
request.get('/api/deviceinspecttasklist/taskDetail', Object.assign({}, options, { params }));

//巡检记录编辑
export const updateInspectRecord = (params, options) =>
request.post('/api/deviceinspecttasklist/taskSubmit',params,options)

//巡检记录删除
export const removeInspectRecord = (id) =>
request.post('/api/deviceinspecttasklist/taskRemove?ids='+id)

//获取设备巡检标准的标准项
export const  taskByStandardId  = (params, options) =>
request.get('/api/deviceinspecttasklist/taskByStandardId', Object.assign({}, options, { params }));